import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LiveLogSettingsDialogModule } from '@portal-core/live-log/components/live-log-settings-dialog/live-log-settings-dialog.module';
import { LiveLogModule } from '@portal-core/live-log/components/live-log/live-log.module';
import { LogStreamGridModule } from '@portal-core/live-log/components/log-stream-grid/log-stream-grid.module';
import { LogTabPanelComponent } from './log-tab-panel.component';

@NgModule({
  declarations: [
    LogTabPanelComponent
  ],
  imports: [
    CommonModule,
    LiveLogModule,
    LiveLogSettingsDialogModule,
    LogStreamGridModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTabsModule,
    MatTooltipModule
  ],
  exports: [
    LogTabPanelComponent
  ]
})
export class LogTabPanelModule { }
